/**
 * Hook misji „Złów jedną rybkę" — tylko EMIT (WP-V2-QC).
 */
import type { InteractEvent } from '../../interact/index.js';
import { GARDEN_QUEST_ID, GARDEN_ROD_DEF_ID, type FishKind } from './objects.js';

export const INTERACT_BUS_EVENT = 'pieskowo:interact';

export type GardenMissionPayload = {
  sceneKey: 'Garden';
  questId: typeof GARDEN_QUEST_ID;
  stepKind: 'catch_fish';
  fishKind: FishKind | null;
  interact?: InteractEvent;
};

export function isRodTapEvent(evt: InteractEvent): boolean {
  return (
    (evt.type === 'tap' || evt.type === 'toggle') &&
    evt.defId === GARDEN_ROD_DEF_ID
  );
}

export function gardenMissionFromCatch(
  fishKind: FishKind,
  evt?: InteractEvent,
): GardenMissionPayload {
  return {
    sceneKey: 'Garden',
    questId: GARDEN_QUEST_ID,
    stepKind: 'catch_fish',
    fishKind,
    interact: evt,
  };
}
